
export default {
  name: 'FilterSelector',
  props: {
    value: { type: [Number, String], required: true },
    checked: { type: Boolean, required: true },
    text: { type: String, required: true },
    variant: { type: String, default: 'check' },
  },
  methods: {
    updateValue(v) {
      this.$emit('change', v);
    },
  },
}
